module.exports = __webpack_public_path__ + "static/media/iconQuestion.98729976.svg";